var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "message button-message" }, [
    _c("div", { staticClass: "bot-response button" }, [
      _c("div", { staticClass: "button-content" }, [
        _c("div", {
          staticClass: "button-description",
          domProps: { innerHTML: _vm._s(_vm.data.message) },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "buttons" },
        _vm._l(_vm.data.buttons, function (button, i) {
          return _c(
            "div",
            {
              key: button.id,
              staticClass: "single-button",
              class: {
                selected:
                  _vm.$_.get(_vm.lastClickedButton, "buttonId") === button.id,
              },
              on: {
                click: function ($event) {
                  return _vm.sendButtonMessage("BUTTON", {
                    buttonId: button.id,
                    blockId: _vm.data.blockId,
                    payloadId: _vm.data.id,
                    buttonPayload: button.payload,
                  })
                },
              },
            },
            [
              _c("div", {
                staticClass: "single-button-text",
                domProps: { innerHTML: _vm._s(button.title) },
              }),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }